import { motion } from "framer-motion";
import {
  Hotel,
  Utensils,
  Wine,
  ShoppingBag,
  Truck,
  Factory,
  Briefcase,
  HardHat,
  Stethoscope,
  GraduationCap,
  Cpu,
} from "lucide-react";
import { industries } from "@/config/site";

const iconMap = {
  Hotel,
  Utensils,
  Wine,
  ShoppingBag,
  Truck,
  Factory,
  Briefcase,
  HardHat,
  Stethoscope,
  GraduationCap,
  Cpu,
};

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div
        className="vs-orb"
        style={{
          width: 500,
          height: 500,
          bottom: -160,
          left: -120,
          background: "var(--vs-ambient-teal)",
        }}
      />
      <div className="vs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-[#d4af37]" />
              <span className="text-overline">Industries We Advise</span>
            </div>
            <h2 className="mt-5 font-serif-display text-4xl md:text-6xl text-white tracking-tight leading-[1.02]">
              Depth across
              <br />
              <span className="italic vs-gold-text">owner-run</span> categories.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-5 text-white/65 font-body leading-relaxed max-w-md"
          >
            From hospitality groups juggling multiple outlets to family businesses navigating
            succession — we bring domain fluency to the CFO seat.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {industries.map((ind, i) => {
            const Icon = iconMap[ind.icon];
            return (
              <motion.div
                key={ind.name}
                data-testid={`industry-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.06 }}
                whileHover={{ y: -3 }}
                className="group vs-glass rounded-sm p-6 md:p-7 flex flex-col justify-between h-40 md:h-44 hover:border-[#d4af37]/40 transition-colors"
              >
                <Icon size={22} className="text-white/60 group-hover:text-[#d4af37] transition-colors" />
                <div>
                  <div className="font-serif-display text-xl md:text-2xl text-white leading-tight">
                    {ind.name}
                  </div>
                  <div className="mt-1 text-[10px] tracking-widest text-white/40 uppercase font-body">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
